import { CloseIcon } from "@/components/flashcards/Icons";

interface InteractiveElementOverlayHeaderProps {
  title: string;
  /** When true, hides the icon close control (completed review uses the footer CTA). */
  showCloseButton?: boolean;
  onClose: () => void;
}

interface OverlayCloseButtonProps {
  visible: boolean;
  onClose: () => void;
}

const OverlayCloseButton = ({ visible, onClose }: OverlayCloseButtonProps) => {
  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Fertig"
      onClick={onClose}
      className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition-colors hover:bg-white/20"
    >
      <CloseIcon />
    </button>
  );
};

/**
 * Gradient title bar for the interactive-element overlay — title + optional close.
 */
const InteractiveElementOverlayHeader = ({
  title,
  showCloseButton = true,
  onClose,
}: InteractiveElementOverlayHeaderProps) => (
  <header className="flex items-center justify-between gap-4 bg-gradient-to-b from-[#07254a] to-[#0a4e80] px-6 pb-4 pt-6 text-white">
    <div
      data-slot="interactive-element-headline"
      className="truncate text-heading-h2 leading-snug text-white"
    >
      {title}
    </div>
    <OverlayCloseButton visible={showCloseButton} onClose={onClose} />
  </header>
);

export default InteractiveElementOverlayHeader;
